<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放 -> 主面板 -> 查定位点 子组件
-->
<template>
	<li class="bgc_green" v-loading="loadingEx" element-loading-text="导出中">
		<dl>
			<dt>
                <p>
                  <input v-if="data.lockFlg !== 1" type="checkbox" v-model='isChecked'>
                  <span>
                  	<a v-show="data.lockFlg==1" class="ico_01a" @click="clickLock(data.lockFlg,data.id)" data-toggle="tracetip" data-placement="bottom" title="解锁"></a>
	              	<a v-show="data.lockFlg!=1" class="ico_01b" @click="clickLock(data.lockFlg,data.id)" data-toggle="tracetip" data-placement="bottom" title="锁定"></a>
                  <!--	<a @click="clickLock(data.lockFlg,data.id)" v-bind:class="[data.lockFlg === 1 ? 'ico_01a' : 'ico_01b']"></a>-->
                  </span>
                  <span class="sp_text">{{data.vehicleInfo.vehicleNum}}</span>
                  <i @click="checkPosition" data-toggle="tracetip" data-placement="bottom" title="查看">
                  	<a class="ico_02"></a>
                  </i>
                  <i @click="exportPosition" data-toggle="tracetip" data-placement="bottom" title="导出">
                  	<a class="ico_04" ><img src="../../../../assets/project/images/map/map_icon_56.png"/></a>
                  </i>
                </p>
                <p><em>{{data.vehicleInfo.plateNumber}}</em><b>{{data.vehicleInfo.ownerName}}</b></p>
				</dt>
			<dd><a class="noLink">查定位点</a><em>VD{{data.deviceId}}</em></dd>
		</dl>
		<div class="details">
			<a  @click="prePoint" class="arrows_l01" ref="lBtn" style="cursor:pointer;"></a>
			<a  @click="nextPoint" class="arrows_r01" ref="rBtn" style="cursor:pointer;"></a>
			<p>
				<span><em>{{posiDate}}</em><em>{{posiTime}}</em></span>
				<span><em>经{{posiLng}}</em><em>纬{{posiLat}}</em></span>
			</p>
		</div>
	</li>
</template>

<script>
	import {mapState} from 'vuex'
	import {Mixin} from './mixin'
	export default{
		mixins:[Mixin],
		data(){
			return{
				isChecked:this.data.isChecked,
				clickPAble:true,
				clickId:0,
				posiLat:'',
				posiLng:'',
				posiTime:'',
				posiDate:'',
				curIndex:'',
				posiInfo:{},
				loadingEx:false,
				positionList:[]
			}
		},
		props: {
			data:{
				type: Object,
				default() {
					return{}
				}
			},
			checked:{
				type:Boolean
			}
		},
		computed:mapState({
			userId:state => state.user.userId
		}),
		watch:{
			data:{
				handler:function(val){
					this.posiDate = val.gpsTime.split(' ')[0]
					this.posiTime = val.gpsTime.split(' ')[1]
					this.posiLng = val.lng
					this.posiLat = val.lat
					this.posiInfo = {
						lngBd:val.lng,
						latBd:val.lat
					}
				},
				deep:true
			},
			curIndex:function(val){
				const arr = this.positionList;
				if(val >= 0 && val < arr.length){
					let dateStr = timeToStr(arr[val].gpsTime);
					this.posiDate = dateStr.split(' ')[0]
					this.posiTime = dateStr.split(' ')[1]
					this.posiLng = arr[val].lng
					this.posiLat = arr[val].lat
					this.posiInfo = arr[val]
				}
			}
		},
		mounted(){//初始化定位点信息--数据来自轨迹队列接口
			this.posiDate = this.data.gpsTime.split(' ')[0]
			this.posiTime = this.data.gpsTime.split(' ')[1]
			this.posiLng = this.data.lng
			this.posiLat = this.data.lat
			this.posiInfo = {
				lngBd:this.data.lng,
				latBd:this.data.lat
			}
		},
		methods: {
			// 点击向左箭头
			prePoint(){
				this.clickId = this.data.id
				if(this.clickPAble){//点第一次
					this.clickPAble = false
					this.getPositionList(-1);
				}else{
					if(this.curIndex > 0){
						this.curIndex --
					} else {
						const obj = {
							tipCnt:'已经是第一个定位点了',
							showBtn:false
						}
						this.$store.dispatch('showModal',obj)
					}
				}
			},
			// 点击向右箭头
			nextPoint(){
				this.clickId = this.data.id
				if(this.clickPAble){//默认第一次不能点击
					this.clickPAble = false;
					this.getPositionList(1);
					return;
				}else{
					if(this.curIndex < this.positionList.length - 1){
						this.curIndex ++
					} else {
						const obj = {
							tipCnt:'已经是最后一个定位点了',
							showBtn:false
						}
						this.$store.dispatch('showModal',obj)
					}
				}
			},
			checkPosition(){//获取定位信息->显示到地图上
				const positionObj = {
					info:this.posiInfo,
					showType:this.data.showType,
					vehicleInfo:this.data.vehicleInfo,
					vId:this.data.id,
					uni:new Date().getTime()
				}
				this.$store.dispatch('setPosition',positionObj)
			},
			exportPosition(){//导出定位点
				//if 有定位点下 TODO：
				this.loadingEx = true
				this.$http.get(process.env.API_ROOT +'/trace/traces/positions/export/' + this.data.id)
				.then((res)=>{
					let str = res.body.data
					var path = process.env.EXPORT_PATH;//'http://192.168.1.87:8888'
					var api = process.env.API_ROOT;
					var fileName = path  + api + '/noauth/export?url=' + str + '&path=' + this.userId;
	    			var elemIF = document.createElement("iframe");   
			      	elemIF.src = fileName;   
			        elemIF.style.display = "none";   
			        document.body.appendChild(elemIF); 
			        this.loadingEx = false
				},(res)=>{
					this.loadingEx = false
					const obj = {
						tipCnt:res.body.message,
						showBtn:false
					}
					this.$store.dispatch('showModal',obj);
				})
				.catch((res)=>{
					this.loadingEx = false
					const obj = {
						tipCnt:res.body.message,
						showBtn:false
					}
					this.$store.dispatch('showModal',obj);
				})
			},
			getPositionList(direc){//-1：向前，index-1；1：向后，index+1
				this.$http.get(process.env.API_ROOT + '/trace/traces/positions/' + this.data.id)
					.then((response) => {
						const obj = response.body.data;
						if(obj.gpsInfoList && obj.gpsInfoList.length !== 0){
							this.positionList = obj.gpsInfoList;
							const length = obj.gpsInfoList.length;
							let timestamp = toTimestamp(this.data.gpsTime);
							let index = (this.positionList.findIndex(function(value, index, arr){
								return value.gpsTime === timestamp;
							}) + direc);
							if(index < 0) {
								index = 0;
								if(direc == -1){
									const obj = {
										tipCnt:'已经是第一个定位点了',
										showBtn:false
									}
									this.$store.dispatch('showModal',obj)						
								}
							}
							if(index >= this.positionList.length) {
								index = this.positionList.length - 1;
								if(direc == 1){
									const obj = {
										tipCnt:'已经是最后一个定位点了',
										showBtn:false
									}
									this.$store.dispatch('showModal',obj)
								}
							}
							this.curIndex = index;
						}else{
							const obj = {
								tipCnt:"无定位信息",
								showBtn:false
							}
							this.$store.dispatch('showModal',obj);
						}
					}, (res) => {
						const obj = {
							tipCnt:res.body.message,
							showBtn:false
						}
						this.$store.dispatch('showModal',obj);
					})
					.catch((res) => {
						const obj = {
							tipCnt:res.body.message,
							showBtn:false
						}
						this.$store.dispatch('showModal',obj);
					})
			}
		}
	}
	function timeToSec(str){
		//	let str = num + ''
			//let sec = 0;
			let h = parseInt(str.substring(6,8));
			let m = parseInt(str.substring(8,10));
			let s = parseInt(str.substring(10));
			//let totalSec = 0;
			return h * 3600 + m * 60 + s;
	}
	
	function timeToStr(gpstime){
		return '20' + gpstime.substring(0,2)
				+ '-' + gpstime.substring(2,4)
				+ '-' + gpstime.substring(4,6)
				+ ' ' + gpstime.substring(6,8)
				+ ':' + gpstime.substring(8,10)
				+ ':' + gpstime.substring(10);
	}
	
	function toTimestamp(timeStr){
		timeStr = timeStr.replace(/[^0-9]/g,"");
		return timeStr.substring(2,timeStr.length);
	}
</script>



// WEBPACK FOOTER //
// VehicleItemLocation.vue?3b8e1764